import { render, staticRenderFns } from "./exampleHeader.vue?vue&type=template&id=6db45836&scoped=true"
import script from "./exampleHeader.vue?vue&type=script&lang=js"
export * from "./exampleHeader.vue?vue&type=script&lang=js"
import style0 from "./exampleHeader.vue?vue&type=style&index=0&id=6db45836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db45836",
  null
  
)

export default component.exports